/* eslint-disable */
import ls from 'local-storage';
import main from './../../main';
import jwt_decode from 'jwt-decode';

const state = {
  AUTH_TOKEN: ls('token'),
};

const mutations = {
  user_login(state, payload) {
    ls('token', payload.token);
    state.AUTH_TOKEN = payload.token;
  },
  user_logout(state) {
    state.AUTH_TOKEN = false;
    ls('token', false);
    main.$router.push('/login');
  },
};

const getters = {
  isLogged: () => {
    const status = state.AUTH_TOKEN ? true : false;
    return status;
  },
  authToken: () => state.AUTH_TOKEN,
  decoded: () => jwt_decode(state.AUTH_TOKEN),
};

export default {
  state,
  getters,
  mutations,
};